export default __webpack_public_path__ + "static/media/stripe.a97bff95.svg";